import { render, staticRenderFns } from "./User.vue?vue&type=template&id=fee82348&scoped=true&"
var script = {}
import style0 from "./User.vue?vue&type=style&index=0&id=fee82348&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fee82348",
  null
  
)

export default component.exports